import service from "@/store/services/stock-movement-items-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  stockMovementItem: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, stockMovementItem) => {
    state.stockMovementItem = stockMovementItem;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((stockMovementItem) => {
      commit("SET_RESOURCE", stockMovementItem);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((stockMovementItem) => {
      commit("SET_RESOURCE", stockMovementItem);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((stockMovementItem) => {
      commit("SET_RESOURCE", stockMovementItem);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  stockMovementItem: (state) => state.stockMovementItem,
  url: (state) => state.url,
};

const stockMovementItems = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default stockMovementItems;
